/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { SearchSttJsonRequestInteface } from "../contracts/CariSttRequest";
import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class SearchSttScanApiRequest implements SearchSttJsonRequestInteface {
  sttNo = "";
  scanLocation = "";
  scanLocationNote = "";

  constructor(fields?: Partial<SearchSttScanApiRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class SearchSttFilter {
  search = "";
  lastStatus = "";
  scanLocation = "";

  constructor(fields?: Partial<SearchSttFilter>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}
